import type { ImageRenderer } from "@msuite/ui/libs/tiptap";
import { useCallback } from "react";
import { WikiImageBlock } from "@/components/wiki/wiki-image-block";

/**
 * Resolves an `imageBlock` to the picture it embeds. Stable across renders on purpose: the editor
 * rebuilds its extension list when the renderer's identity changes, which would tear the editor
 * down mid-keystroke.
 */
export function useImageRenderer(): ImageRenderer {
	return useCallback<ImageRenderer>((attrs) => <WikiImageBlock fileId={attrs.fileId} />, []);
}
